import { helpers } 		from './theme/helpers.js';
import { hamburger } 	from './theme/components/hamburger.js';


window.theme = {
	globals: {
		isTouch: typeof window !== 'undefined' && 'ontouchstart' in window,
		isTabActive: true,
		scroll: {
			last: 0,
			min: 300,
			class: 'scrolling-down'
		},
		headerMessageClass: '.header__message',
		headerMessageCloseClass: '.header__message__close',
	},
	
	init: function () {
		var self = this;

		hamburger.init();

		console.log( 'hehe' );

		// Global
		self.onloadClass();
		self.touch();
		self.smoothScroll.init();

		self.plusMinus();

		self.headerMessage();

		jQuery( document.body ).on( 'updated_cart_totals', function(){
			self.plusMinus();
		});

		var instockCheckbox = document.getElementById('instock');
    
		if (instockCheckbox) {
			instockCheckbox.addEventListener('change', function() {
				document.getElementById('filter').submit();
			});
		}

		jQuery( '.woocommerce-product-gallery__image a' ).fancybox({
			// FancyBox options (optional)
			buttons : [
				'zoom',
				'share',
				'slideShow',
				'fullScreen',
				'thumbs',
				'close'
			],
			loop: true,
			protect: true
		});
	},

	headerMessage: function() {
		var self = this;

		if( ! jQuery( self.globals.headerMessageClass ).length ) {
			return false;
		}


		if( helpers.getCookie( 'headerMessageClose' ) == 'true' ) {
			jQuery( self.globals.headerMessageClass ).remove();
			return false;
		}

		self.resizeContent();

		jQuery( document ).on( 'click', self.globals.headerMessageCloseClass, function( e ){
			e.preventDefault();

			helpers.setCookie( 'headerMessageClose', true, 7 );
			jQuery( self.globals.headerMessageClass ).remove();
			jQuery( '#site-content' ).css( 'padding-top', '' );
		});
	},

		resizeContent: function() {
			var self = this;

			let fullHeight = jQuery( self.globals.headerMessageClass ).outerHeight() / 16;
			jQuery( '#site-content' ).css( 'padding-top', `${fullHeight}rem` );
		},

	onloadClass: function () {
		document.querySelector('body').classList.add('loaded');
	},

	touch: function () {
		var self = this;

		var touchClass = self.globals.isTouch === true ? 'touch-device' : 'pointer-device';
		document.querySelector('body').classList.add( touchClass );
	},

	smoothScroll: {
		selector: 'a[href*="#"]:not([href="#"])',
		init: function () {
			var self = this;

			var scroll = new SmoothScroll(self.selector, {
				ignore: '[data-scroll-ignore]',
				topOnEmptyHash: false,
				speed: 1000,
				offset: function (anchor, toggle) {

					var width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

					var elementTarget = width > 992 ? '.header__nav' : '.header__main';
					var headerOffset =  jQuery( elementTarget ).outerHeight();
					headerOffset = headerOffset + 9;

					// if( jQuery( anchor ).offset().top < jQuery( window ).scrollTop() + headerOffset ) {
					// 	headerOffset = jQuery( '.header.header--p-fixed' ).css( '--header-height' )
					// 	headerOffset = headerOffset.replace( 'px', '');
					// }

					// if( !headerOffset ) {
					// 	headerOffset = 0;
					// }
	
					return headerOffset;
				},
				updateURL: false,
				easing: 'easeInOutCubic',
			});
		},
	},

	plusMinus: function () {
		var self = this;

		if( document.querySelectorAll( '.quantity' ).length == 0 ) {
			return false;
		}

		const isCartPage = document.querySelector( 'body' ).classList.contains( 'woocommerce-cart' );

		document.querySelectorAll( '.quantity' ).forEach(( quantitySelector ) => {
			const quantityInput = quantitySelector.querySelector('input.qty');

			// Select the plus and minus buttons
			const plusButton = quantitySelector.querySelector('.qty-plus');
			const minusButton = quantitySelector.querySelector('.qty-minus');
	
			if( !quantityInput || !plusButton || !minusButton ) {
				return;
			}
		
			// Increment the value
			plusButton.addEventListener('click', () => {
				let currentValue = parseInt(quantityInput.value);
				let maxValue = quantityInput.getAttribute('max') ? parseInt(quantityInput.getAttribute('max')) : Infinity;

				if (currentValue < maxValue) {
					quantityInput.value = currentValue + 1;
				}

				if( isCartPage ) self.updateCart();
			});
		
			// Decrement the value
			minusButton.addEventListener('click', () => {
				let currentValue = parseInt(quantityInput.value);
				let minValue = quantityInput.getAttribute('min') ? parseInt(quantityInput.getAttribute('min')) : 0;

				if (currentValue > minValue) {
					quantityInput.value = currentValue - 1;
				}

				if( isCartPage ) self.updateCart();
			});
		});
	},

		updateCart: function() {
			document.querySelector( '[name="update_cart"]' ).removeAttribute( 'disabled' );
		},

	windowPosition: function () {
		return {
			x: window.pageXOffset || document.documentElement.scrollLeft,
			y: window.pageYOffset || document.documentElement.scrollTop,
		};
	},

	windowSizes: function () {
		return {
			width: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
			height: Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0),
		};
	},

	onresize() {
		var self = this;

		self.headerMessage();
	},

	onscroll() {
		var self = this;

		const currentScroll = window.pageYOffset;

		if ( currentScroll > self.globals.scroll.last && currentScroll > self.globals.scroll.min ) {
			document.body.classList.add( self.globals.scroll.class );
		} else if ( currentScroll < self.globals.scroll.last ) {
			document.body.classList.remove( self.globals.scroll.class );
		}

		self.globals.scroll.last = currentScroll;
	},
};

jQuery(function() {
	theme.init();
});

window.addEventListener('scroll', function (e) {
	theme.onscroll();  	
});

window.addEventListener('resize', function (e) {
	theme.onresize();
});

window.onfocus = function () { 
	theme.globals.isTabActive = true; 
}; 

window.onblur = function () { 
	theme.globals.isTabActive = false; 
};
